import { render } from "./ScheduleDeleteButton.vue?vue&type=template&id=32e85a55"
import script from "./ScheduleDeleteButton.vue?vue&type=script&lang=ts"
export * from "./ScheduleDeleteButton.vue?vue&type=script&lang=ts"
script.render = render

export default script